import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=b2e7c2f2&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=b2e7c2f2&prod&scoped=true&lang=css"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=b2e7c2f2&prod&lang=css"
import style2 from "./sidebar.vue?vue&type=style&index=2&id=b2e7c2f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e7c2f2",
  null
  
)

export default component.exports